import React from "react";
import { Link } from "react-router-dom";

export default function NavItem({ href, title }) {
  return (
    <li className="list-none text-slate-100 w-full font-semibold hover:bg-slate-500 hover:text-white my-2 py-2 px-2">
      <Link to={href}>{title}</Link>
    </li>
  );
}
